import { Component, Input } from '@angular/core';

import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

import { ReturnTypesService } from '../../services/return-types.service';
import { ReturnTypeWithCredential } from '../../models/return-type.model';
import { map } from 'rxjs/operators';

@Component({
    selector: 'spv2-return-type-by-credential-type-dropdown',
    templateUrl: './dropdown-base/dropdown-base.component.html',
    styleUrls: ['./dropdown-base/dropdown-base.component.scss'],
    standalone: false
})
export class ReturnTypeByCredentialTypeDropdownComponent extends DropdownBaseComponent<string | string[], ReturnTypeWithCredential> {
  
  private _jurisdiction : string;
  @Input() public set jurisdiction(v : string) {
    if(this.value && this._jurisdiction) {
      this.value = null;
      this.valueChange.emit(this.value);
    }
    this._jurisdiction = v;
    this.debounceTrigger.execute(null);
  }
  
  get uniqueName() {
    return "ReturnTypesWithCredentialType" + this._jurisdiction;
  } 

  textField = "name";
  valueField = "code";
  enableCache = false;
  loadDataAutomatically = false;

  dataFunction = (_: any) => { 
    if(this._jurisdiction) return this.returnTypeService.getReturnAndCredentialTypes(this._jurisdiction).pipe(map(x => x ? x.returnTypes : []));
  }

  constructor(private returnTypeService: ReturnTypesService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }

  itemDisabled(itemArgs: { dataItem: ReturnTypeWithCredential; index: number }): boolean {
    if(this.value?.length > 0) {
      let returnType: ReturnTypeWithCredential;
      this.data$.subscribe(x => returnType = x.find(x => x[this.valueField] === this.value[0]));
      return itemArgs.dataItem.credentialType !== returnType.credentialType;
    }

    return false;
  }
}
